"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReferredUsersResponseToJSON = exports.ReferredUsersResponseFromJSONTyped = exports.ReferredUsersResponseFromJSON = void 0;
var _1 = require("./");
function ReferredUsersResponseFromJSON(json) {
    return ReferredUsersResponseFromJSONTyped(json, false);
}
exports.ReferredUsersResponseFromJSON = ReferredUsersResponseFromJSON;
function ReferredUsersResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'referredUsersData': (json['referredUsersData'].map(_1.ReferredUserDataFromJSON)),
    };
}
exports.ReferredUsersResponseFromJSONTyped = ReferredUsersResponseFromJSONTyped;
function ReferredUsersResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'referredUsersData': (value.referredUsersData.map(_1.ReferredUserDataToJSON)),
    };
}
exports.ReferredUsersResponseToJSON = ReferredUsersResponseToJSON;
